<div class="pl-2 w-100" [style.height]="(page === 'park-monitor') ? 'calc(100% - 196px)' : '100%'">
  <div class="w-100 h-100">
    <div #powerForecastChart style="display: block; height: 200px">
      @if (chartDatasets) {
        <highcharts-chart
          class="w-100 d-block"
          [Highcharts]="highcharts"
          [options]="chartOptions"
          [callbackFunction]="chartCallback">
        </highcharts-chart>
      }
    </div>
  </div>
</div>